<div class="test-container">
    <canvas #skyCanvas class="sky-canvas"></canvas>
    <div id="map" class="map-container" [class.loaded]="isMapReady"></div>

    <app-being-vitals *ngIf="currentBeing" [beingId]="currentBeing?.id"></app-being-vitals>

    <!-- <app-notion-lens *ngIf="currentBeing" [beingId]="currentBeing?.id"></app-notion-lens> -->


    <div class="map-stats-sidebar">
        <!-- <div class="stats-header">Map activity</div> -->

        <div class="stats-group">
            <div class="stat-row">
                <span class="stat-label">Zoom level</span>
                <span class="stat-value">{{ currentZoom | number: '1.1-1' }}</span>
            </div>
            <div class="stat-row">
                <span class="stat-label">Markers in view</span>
                <span class="stat-value" [style.color]="visibleDiscoveriesCount > 0 ? '#3b82f6' : '#6b7280'">
                    {{ visibleDiscoveriesCount }}
                </span>
            </div>
            <div class="stat-row">
                <span class="stat-label">Total discoveries</span>
                <span class="stat-value">{{ discoveries.length }}</span>
            </div>
        </div>

        <div class="stats-group">
            <div class="stats-sub-header">Beings on the Map</div>
            <div class="count-wrapper">
                <div class="status-badge">
                    <div class="status-dot alive"></div>
                    <span>Alive: {{ aliveCount }}</span>
                </div>
                <div class="status-badge">
                    <div class="status-dot dead"></div>
                    <span>Dead: {{ deadCount }}</span>
                </div>
                <button class="contact-button" (click)="goToContact()">
                    <span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 1024 1024">
                            <path d="M0 0h1024v1024H0z" fill="none" />
                            <path fill="currentColor"
                                d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448s448-200.6 448-448S759.4 64 512 64m0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372s372 166.6 372 372s-166.6 372-372 372" />
                            <path fill="currentColor"
                                d="M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7c-21.2 8.1-39.2 22.3-52.1 40.9c-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0 1 30.9-44.8c59-22.7 97.1-74.7 97.1-132.5c.1-39.3-17.1-76-48.3-103.3M472 732a40 40 0 1 0 80 0a40 40 0 1 0-80 0" />
                        </svg>

                    </span>
                </button>
            </div>



            <small>
                <p>v.165.120926</p>
            </small>
        </div>

        <!-- <div class="stats-group">
            <div class="stats-sub-header">Hint</div>
            <p class="stats-hint">Zoom to z14+ to see beings. Check hot zones (red) for marker clusters.</p>
        </div> -->
    </div>

    <div class="top-right-hand-btns-wrapper">

        <button class="being-button" (click)="zoomToBeing()">
            <svg xmlns="http://www.w3.org/2000/svg" width="2em" height="2em" viewBox="0 0 24 24">
                <path d="M0 0h24v24H0z" fill="none" />
                <path fill="currentColor"
                    d="M9.25 12a.75.75 0 0 1 .75-.75h1.25V10a.75.75 0 0 1 1.5 0v1.25H14a.75.75 0 0 1 0 1.5h-1.25V14a.75.75 0 0 1-1.5 0v-1.25H10a.75.75 0 0 1-.75-.75" />
                <path fill="currentColor" fill-rule="evenodd"
                    d="M12 1.25C6.063 1.25 1.25 6.063 1.25 12S6.063 22.75 12 22.75S22.75 17.937 22.75 12S17.937 1.25 12 1.25m-.75 1.53a9.25 9.25 0 0 0-8.47 8.47H5a.75.75 0 0 1 0 1.5H2.78a9.25 9.25 0 0 0 8.47 8.47V19a.75.75 0 0 1 1.5 0v2.22a9.25 9.25 0 0 0 8.47-8.47H19a.75.75 0 0 1 0-1.5h2.22a9.25 9.25 0 0 0-8.47-8.47V5a.75.75 0 0 1-1.5 0z"
                    clip-rule="evenodd" />
            </svg>
        </button>



        <button class="chat-toggle-btn" *ngIf="!isOpen && currentBeing" (click)="toggleChat()" aria-label="Open chat">
            <span class="toggle-icon">💬</span>
            <span class="toggle-label" *ngIf="currentBeing">{{ currentBeing['name'] }}</span>
        </button>



        <button class="being-button" (click)="toggleGraticuleVisibility()">
            <svg xmlns="http://www.w3.org/2000/svg" width="2em" height="2em" viewBox="0 0 24 24">
                <path d="M0 0h24v24H0z" fill="none" />
                <g fill="none">
                    <path
                        d="m12.594 23.258l-.012.002l-.071.035l-.02.004l-.014-.004l-.071-.036q-.016-.004-.024.006l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.016-.018m.264-.113l-.014.002l-.184.093l-.01.01l-.003.011l.018.43l.005.012l.008.008l.201.092q.019.005.029-.008l.004-.014l-.034-.614q-.005-.019-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.003-.011l.018-.43l-.003-.012l-.01-.01z" />
                    <path fill="#ccc7c7"
                        d="M4.859 19a9.97 9.97 0 0 0 7.14 3a9.97 9.97 0 0 0 7.142-3zm-1.521-2a9.9 9.9 0 0 1-1.289-4h19.902a9.9 9.9 0 0 1-1.289 4zm18.613-6H2.049a9.9 9.9 0 0 1 1.289-4h17.324a9.9 9.9 0 0 1 1.289 4M12 2a9.97 9.97 0 0 0-7.141 3H19.14A9.97 9.97 0 0 0 12 2" />
                </g>
            </svg>
        </button>

        <!-- <button class="being-button" type="button" [attr.aria-label]="'View learning history for ' + being?.name"
            (click)="goToStats(being!.id)">
            <svg xmlns="http://www.w3.org/2000/svg" width="2em" height="2em" viewBox="0 0 24 24" aria-hidden="true">
                <path d="M0 0h24v24H0z" fill="none" />
                <path fill="currentColor"
                    d="M19 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m0 16H5V5h14zM9 17H7v-5h2zm4 0h-2V7h2zm4 0h-2v-7h2z" />
            </svg>
        </button> -->

    </div>

    <app-being-chat *ngIf="currentBeing" [being]="currentBeing" [isOpen]="isOpen" (closed)="isOpen = false">
    </app-being-chat>

    <!-- empty state -->
    <div class="birth-prompt" *ngIf="!hasBeings && beingsLoaded && !isMapLoading && shouldShowBirthPrompt">
        <button class="birth-prompt__close" (click)="closePrompt()" aria-label="Close prompt">
            <span aria-hidden="true">&times;</span>
        </button>

        <p *ngIf="!hasBeings && deadUserBeings.length === 0" class="birth-prompt__lead">
            The world is turning. Nothing of yours lives in it yet.
        </p>

        <div class="birth-prompt__lead">
            {{ beingDeadMessage }}
        </div>

        <button class="birth-button" (click)="birthBeing()" [disabled]="isBirthing">
            <span>{{ isBirthing ? 'Searching for habitable ground…' : 'Begin a lineage' }}</span>
        </button>

        <p class="birth-prompt__error" *ngIf="birthError">{{ birthError }}</p>
    </div>

    <!-- newborn: name it -->
    <div class="birth-prompt" *ngIf="newborn">

        <input #nameInput class="birth-input" type="text" maxlength="24" [placeholder]="newborn.name"
            (keyup.enter)="confirmName(nameInput.value)">

        <div class="birth-prompt__actions">
            <button class="birth-button" (click)="confirmName(nameInput.value)">Name it</button>
            <button class="birth-button birth-button--ghost" (click)="newborn = null">
                Keep {{ newborn.name }}
            </button>
        </div>
    </div>

    <div class="camera-button-container">

        <button class="camera-button" (click)="handleButtonClickPhoto()" [disabled]="isCapturingPhoto" shape="round"
            color="primary">
            <div class="svg-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" [class.rotate]="isAnimating">
                    <path fill="blue"
                        d="m11.2 8.375l3.5-6q2.275.6 4.038 2.2t2.562 3.8zm-2.775 2.5L5 4.875q1.35-1.325 3.138-2.1T12 2q.325 0 .75.038t.775.087zm-6.1 3.625q-.15-.6-.238-1.225T2 12q0-1.775.575-3.35T4.2 5.775L9.25 14.5zm7 7.125q-2.275-.6-4.05-2.2t-2.575-3.8h10.075zM12 22q-.375 0-.763-.05t-.737-.1l5.075-8.725l3.425 6q-1.35 1.325-3.137 2.1T12 22m7.8-3.775L14.75 9.5h6.925q.15.6.238 1.225T22 12q0 1.75-.612 3.35T19.8 18.225" />
                </svg>
            </div>
        </button>

        <button class="video-button" (click)="handleButtonClickVideo()" [disabled]="isCapturingVideo" shape="round"
            color="primary">
            <div class="svg-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    <path fill="#f15428"
                        d="M17 10.5V7a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-3.5l4 4v-11z" />
                </svg>
            </div>
        </button>


        <div *ngIf="isCapturingVideo" class="modal-overlay">
            <div class="modal-content">
                <app-video-recorder #videoRecorder (recordingComplete)="onRecordingComplete($event)"
                    [maxRecordingTime]="30">
                </app-video-recorder>
            </div>
            <button class="close-button" (click)="cancelVideoCapture()">
                Cancel
            </button>
        </div>

        <button class="audio-button" (click)="handleButtonClickAudio()" [disabled]="isCapturingVideo" shape="round"
            color="primary">
            <div class="svg-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
                    <path fill="#f15428"
                        d="M842 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8c0 140.3-113.7 254-254 254S258 594.3 258 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8c0 168.7 126.6 307.9 290 327.6V884H326.7c-13.7 0-24.7 14.3-24.7 32v36c0 4.4 2.8 8 6.2 8h407.6c3.4 0 6.2-3.6 6.2-8v-36c0-17.7-11-32-24.7-32H548V782.1c165.3-18 294-158 294-328.1M512 624c93.9 0 170-75.2 170-168V232c0-92.8-76.1-168-170-168s-170 75.2-170 168v224c0 92.8 76.1 168 170 168m-94-392c0-50.6 41.9-92 94-92s94 41.4 94 92v224c0 50.6-41.9 92-94 92s-94-41.4-94-92z"
                        stroke-width="25.5" stroke="#f15428" />
                </svg>
            </div>
        </button>

        <div *ngIf="isCapturingAudio" class="modal-overlay">
            <div class="modal-content">
                <app-audio-recorder (recordingComplete)="onAudioRecordingComplete($event)"
                    (recordingStopped)="onRecordingStopped()" [maxRecordingTime]="60">
                </app-audio-recorder>
            </div>
            <button class="close-button" (click)="cancelAudioCapture()">
                Cancel
            </button>
        </div>

    </div>

    <div #modalContainer></div>

</div>